export class ToggleText {

    private element: HTMLElement

    constructor(element: HTMLElement) {
        this.element = element;
        this.initEvents();
    }

    private initEvents(): void {
        this.element.addEventListener('click', () => {
            let newText = this.element.dataset.toggleText;

            this.element.dataset.toggleText = this.element.innerText;
            this.element.innerText = newText;

        });
    }
}

export const autoInitToggleText = () => {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('[data-toggle-text]').forEach((el: HTMLElement) => {
            new ToggleText(el);
        });
    });
}
